import script from "./search_result.vue?vue&type=script&setup=true&lang=js"
export * from "./search_result.vue?vue&type=script&setup=true&lang=js"

import "./search_result.vue?vue&type=style&index=0&id=68cbc8b6&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68cbc8b6"]])

export default __exports__